export interface TemplateFormQuestionOption {
	text: string
	requiredExplain: boolean
}

export enum TemplatedFormQuestionEnum {
	singleChoice = "singleChoice",
	multipleChoice = "multipleChoice",
	text = "text",
}

export interface TemplatedFormQuestion {
	questionText: string
	required: boolean
	options?: TemplateFormQuestionOption[]
	type: TemplatedFormQuestionEnum
}

export interface TemplatedFormParamsAnswer {
	questionText: string
	textAnswer: string
	selectOptions?: {
		option: string
		explain: string
	}[]
}

export interface TemplatedFormParams {
	template: string
	answers?: TemplatedFormParamsAnswer[]
}
